import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import vi from './locales/vi.json'

const messages = { en, vi } as const

const getLocale = () => (window.location.pathname.startsWith('/vi') ? 'vi' : 'en')

const i18n = createI18n({
  legacy: false,
  locale: getLocale(),
  fallbackLocale: 'en',
  messages,
})

export const syncLocale = () => {
  i18n.global.locale.value = getLocale()
}

export default i18n
